import React from 'react'; // react libary
import ReactDOM from 'react-dom'; // react dom / glue between react elements and the DOM
import './index.css'; // 
import App from './Components/App';
import * as serviceWorker from './serviceWorker'; // helps to load the app faster
import {BrowserRouter} from 'react-router-dom';

//const greeting = React.createElement('h1', {},"Hello World!");
/*const getcurrentDate = () => {
    const date = new Date();  
    return date.toDateString();
}

const greeting = <h1>Hello World! at {getcurrentDate()}</h1>;*/
ReactDOM.render(
    <BrowserRouter>
<App /></BrowserRouter>
, document.getElementById('root')

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
